import { useEffect, useState } from "react";

/**
 * Big rotating word — cycles through the list with a smooth slide/fade transition.
 * Used in the hero as a single-line marquee replacement for the static category list.
 */
export default function RotatingWord({
  words = ["Education", "Industrial", "Automation"],
  intervalMs = 2200,
  className = "",
}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % words.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [words.length, intervalMs]);

  return (
    <span
      className={`relative inline-flex items-center align-baseline ${className}`}
      aria-live="polite"
      data-testid="rotating-word"
    >
      {words.map((w, i) => (
        <span
          key={w}
          className="absolute left-0 top-0 transition-all duration-700 ease-out whitespace-nowrap"
          style={{
            opacity: i === index ? 1 : 0,
            transform: `translateY(${i === index ? "0" : i < index ? "-30%" : "30%"})`,
            pointerEvents: i === index ? "auto" : "none",
          }}
        >
          {w}
        </span>
      ))}
      {/* invisible sizer so the layout reserves space for the widest word */}
      <span className="invisible whitespace-nowrap">
        {words.reduce((a, b) => (b.length > a.length ? b : a), "")}
      </span>
    </span>
  );
}
